import { createContext, useContext, useEffect, useState } from "react";
import adminApi from "@/lib/adminApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = comprobando, false = no auth, obj = autenticado

  useEffect(() => {
    const token = localStorage.getItem("pc_admin_token");
    if (!token) {
      setAdmin(false);
      return;
    }
    adminApi
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("pc_admin_token");
        setAdmin(false);
      });
  }, []);

  const login = async (email, password) => {
    const r = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("pc_admin_token", r.data.token);
    setAdmin(r.data);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("pc_admin_token");
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
